import { Icon } from '@iconify/react';
import markerPath from '@iconify/icons-mdi/map-marker-path';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
// material
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Divider,
  useMediaQuery,
  Badge
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { useEffect, useState } from 'react';
import FlightReviewInfo from './FlightReviewInfo';
import FlightReviwRoulage from './FlightReviewRoulage';
import FlightReviewTakeOff from './FlightReviewTakeOff';
import FlightReviewVol from './FlightReviewVol';
import FlightReviewLanding from './FlightReviewLanding';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectAbonnementData, selectLastFreeFlightUser } from '../../createSelectorUtils';
// utils

/// ----------------------------------------------------------------------

const SideBarCard = styled(Box)(() => ({
  overflow: 'auto',
  mb: 3,
  height: '68%'
}));

// ----------------------------------------------------------------------
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

// ----------------------------------------------------------------------

FlightReviewSideBar.propTypes = {
  reportTrip: PropTypes.object,
  positions: PropTypes.array,
  analyse: PropTypes.object,
  events: PropTypes.array,
  state: PropTypes.object,
  setState: PropTypes.func,
  device: PropTypes.object
};
export default function FlightReviewSideBar({
  reportTrip,
  positions,
  analyse,
  events,
  state,
  setState,
  device
}) {
  const t = useTranslation();
  const Up = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  const abonnementData = useSelector(selectAbonnementData);
  const lastFreeFlightUser = useSelector(selectLastFreeFlightUser);

  const abonnement = abonnementData
    ? true
    : lastFreeFlightUser === null ||
      (reportTrip &&
        new Date(reportTrip.startTime).getTime() <= new Date(lastFreeFlightUser).getTime());

  const [valueTabs, setValueTabs] = useState(0);

  useEffect(() => {
    if (state.currentPhase !== 'all') {
      switch (state.currentPhase) {
        case 'roulages':
          setValueTabs(1);
          break;
        case 'decollages':
          setValueTabs(2);
          break;
        case 'vols':
          setValueTabs(3);
          break;
        case 'atterrissages':
          setValueTabs(4);
          break;
        default:
          break;
      }
    }
  }, [state.currentPhase]);

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
    switch (newValue) {
      case 0:
        setState({ ...state, currentPhase: 'all', selectedListItem: -1, currentPosition: 0 });
        break;
      case 1:
        setState({ ...state, currentPhase: 'roulages', selectedListItem: -1, currentPosition: 0 });
        break;
      case 2:
        setState({
          ...state,
          currentPhase: 'decollages',
          selectedListItem: -1,
          currentPosition: 0
        });

        break;
      case 3:
        setState({ ...state, currentPhase: 'vols', selectedListItem: -1, currentPosition: 0 });
        break;
      case 4:
        setState({
          ...state,
          currentPhase: 'atterrissages',
          selectedListItem: -1,
          currentPosition: 0
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Box sx={{ overflow: 'hidden' }}>
        <Box sx={{ overflowX: 'auto', overflowY: 'hidden' }}>
          <BottomNavigation value={valueTabs} onChange={handleChangeTabs} showLabels={Up}>
            <BottomNavigationAction
              label={t('FR_Details_All')}
              icon={<Icon icon={markerPath} width={24} height={24} />}
              sx={{ ml: 2 }}
            />

            <BottomNavigationAction
              label={t('DB_Taxiing')}
              icon={
                <Badge badgeContent={abonnement ? null : 'pro'} color="secondary">
                  <Icon icon="octicon:paper-airplane-24" width={24} height={24} />{' '}
                </Badge>
              }
              sx={{ ml: -2 }}
              disabled={!abonnement}
            />

            <BottomNavigationAction
              label={t('DB_TakeOff')}
              icon={
                <Badge badgeContent={abonnement ? null : 'pro'} color="secondary">
                  <Icon icon="fa-regular:paper-plane" width={24} height={24} />
                </Badge>
              }
              sx={{ ml: -2 }}
              disabled={!abonnement}
            />
            <BottomNavigationAction
              label={t('DB_Flight')}
              icon={
                <Badge badgeContent={abonnement ? null : 'pro'} color="secondary">
                  <Icon icon="octicon:paper-airplane-24" rotate={3} width={24} height={24} />
                </Badge>
              }
              sx={{ ml: -2 }}
              disabled={!abonnement}
            />
            <BottomNavigationAction
              label={t('DB_Landing')}
              icon={
                <Badge badgeContent={abonnement ? null : 'pro'} color="secondary">
                  <Icon icon="fa-regular:paper-plane" rotate={1} width={24} height={24} />
                </Badge>
              }
              sx={{ ml: -2 }}
              disabled={!abonnement}
            />
          </BottomNavigation>
        </Box>

        <Divider />
      </Box>
      <SideBarCard>
        <TabPanel value={valueTabs} index={0}>
          <FlightReviewInfo reportTrip={reportTrip} positions={positions} analyse={analyse} />
        </TabPanel>
        <TabPanel value={valueTabs} index={1}>
          <FlightReviwRoulage
            analyse={analyse}
            positions={positions}
            state={state}
            setState={setState}
            device={device}
          />
        </TabPanel>
        <TabPanel value={valueTabs} index={2}>
          <FlightReviewTakeOff
            analyse={analyse}
            positions={positions}
            state={state}
            setState={setState}
            device={device}
          />
        </TabPanel>
        <TabPanel value={valueTabs} index={3}>
          <FlightReviewVol
            analyse={analyse}
            positions={positions}
            events={events}
            state={state}
            setState={setState}
            device={device}
          />
        </TabPanel>
        <TabPanel value={valueTabs} index={4}>
          <FlightReviewLanding
            analyse={analyse}
            positions={positions}
            state={state}
            setState={setState}
            device={device}
          />
        </TabPanel>
      </SideBarCard>
    </>
  );
}
